import React, { Fragment } from 'react'

function PrivacyPolicyPage() {
  return (
    <Fragment>
      <div className="container py-4">
        <h2 className="mb-3">Privacy Policy – Best Basket (ML Agro Sarvpriye)</h2>
        <div className="bg-white p-3 rounded shadow-sm" style={{fontSize: '1.05em', lineHeight: '1.65'}}>
          <p>We (“ML Agro Sarvpriye”, “Best Basket”, “we”, “our”, “us”) are committed to protecting your personal information. This Privacy Policy explains what we collect, why we collect it, how we use it, how long we keep it, and the choices you have. It applies to our mobile application and related services.</p>

          <b>1. Categories of Data We Collect</b><br/>
          <u>a. Account & Contact Data</u>: Mobile number; saved delivery addresses (name, house, area, landmark, city, phone); optional feedback text.<br/>
          <u>b. Order & Transaction Data</u>: Items ordered, offer usage, payment method (COD / Pay Now), payment status, internal payment references (merchant order ID). We never store full card or UPI credentials—payment processing is handled securely by our payment partner (PhonePe / gateway).<br/>
          <u>c. Device / Technical Data</u>: IP address, device type, OS version, app version, basic diagnostic logs (crash or performance logs—if enabled).<br/>
          <u>d. Optional Location Data</u>: If you grant permission, approximate location to suggest service availability or improve address accuracy. Denying permission will not block normal ordering (you can enter address manually).<br/>
          <u>e. Derived / Internal Data</u>: Offer eligibility, risk flags (fraud prevention), aggregated purchase statistics.<br/>
          <u>f. Data Not Collected</u>: We do not collect contacts, SMS content, microphone, camera, precise background location, or sensitive biometric information.<br/><br/>

          <b>2. How We Use Data (Purposes)</b><br/>
          • Provide core service: account recognition, cart, order placement & fulfillment.<br/>
          • Payment processing initiation & reconciliation (verifying payment status before confirming orders).<br/>
          • Customer communication: order status, transactional notifications (SMS / in-app).<br/>
          • Offer & complimentary product eligibility logic.<br/>
          • Fraud & abuse prevention (detect repeated failed payments or misuse).<br/>
          • Analytics to improve product assortment & performance (only aggregated / anonymized where possible).<br/>
          • Legal compliance, dispute handling, and security monitoring.<br/><br/>

          <b>3. Legal Bases (Where Applicable)</b><br/>
          • Performance of a contract (fulfilling your order).<br/>
          • Legitimate interests (service improvement, fraud prevention, analytics).<br/>
          • Consent (optional marketing, location permission).<br/>
          • Legal obligation (records retention, responding to lawful requests).<br/><br/>

          <b>4. Sharing & Disclosure</b><br/>
          We do <u>not</u> sell personal data. We share limited data only with:<br/>
          • Payment gateway (PhonePe / similar) – to process your transaction.<br/>
          • Logistics / delivery facilitation (internal or trusted partners) – address & contact for delivery.<br/>
          • Infrastructure & cloud / hosting providers – secure application operation (e.g., hosting, storage, monitoring).<br/>
          • Law enforcement / regulators – only when legally required.<br/>
          • Analytics or crash tools (if integrated) – with IP/device-level data minimized or anonymized where possible.<br/>
          All partners are contractually bound to handle data securely and only for the stated purpose.<br/><br/>

          <b>5. Payment Information</b><br/>
          We do not store card PAN, CVV, UPI PIN, or other sensitive instrument details. PhonePe (or the payment facilitator) processes payments on its PCI-DSS compliant infrastructure. We retain only the payment method, status (paid / pending / failed), and merchant order identifiers needed for reconciliation & refunds.<br/><br/>

          <b>6. Data Retention</b><br/>
          • Active account data: retained while your account is in use.<br/>
          • Order & transactional records: retained as required for taxation, accounting, fraud prevention, and legitimate business records (typically 5–7 years, jurisdiction dependent).<br/>
          • Anonymization: When you delete your account, we anonymize historical orders (removing personal address & mobile) while retaining non-personal order lines for business metrics.<br/><br/>

          <b>7. Account & Data Deletion</b><br/>
          You can request deletion via the in-app “Delete Account” feature or by contacting us. Process:<br/>
          1. We soft-delete the user record (mark as deleted; remove addresses & identifiers).<br/>
          2. We anonymize past orders (no personal name, house, phone).<br/>
          3. Non-personal aggregated data is retained (cannot be linked back).<br/>
          4. Legitimate retention (e.g., legal disputes, fraud) may delay or limit full deletion in narrow cases.<br/><br/>

          <b>8. Your Rights</b><br/>
          Subject to local laws, you may: access, correct, delete, restrict, or object to certain processing; withdraw consent (for optional marketing/location); obtain a copy of certain data (portability). Reach us at <a href="mailto:mlagro999sarvpriya@gmail.com">mlagro999sarvpriya@gmail.com</a>. We will verify requests to protect your account.<br/><br/>

          <b>9. Security Measures</b><br/>
          • HTTPS encryption in transit.<br/>
          • Limited internal access on a need-to-know basis.<br/>
          • Server-side validation & fraud monitoring.<br/>
          • Regular patching & basic malware scans.<br/>
          No system is perfectly secure; you should use a secure network and keep your device updated.<br/><br/>

          <b>10. Children’s Privacy</b><br/>
          Service is not directed to children under 13. We do not knowingly collect data from them. If we learn a child has provided data, we will delete it promptly.<br/><br/>

          <b>11. International Transfers</b><br/>
          If servers or processors are located outside your region, we implement safeguards (contractual clauses / equivalent) to protect your data. By using the service, you consent to such transfers as allowed by law.<br/><br/>

          <b>12. Changes to This Policy</b><br/>
          We may update this policy for operational, legal, or regulatory reasons. Material changes will be signaled in-app or via updated “Last Updated” date. Continued use constitutes acceptance of the revised policy.<br/><br/>

          <b>13. Contact</b><br/>
          ML Agro Sarvpriye<br/>
          Email: <a href="mailto:mlagro999sarvpriya@gmail.com">mlagro999sarvpriya@gmail.com</a><br/>
          Phone: +91 7390917095<br/>
          Address: Bareilly, India<br/><br/>

          <b>Last Updated: September 19, 2025</b>
        </div>
      </div>
      <div className='mt-5 mb-5'></div>
    </Fragment>
  )
}

export default PrivacyPolicyPage